<template>
    <div
        class="flex-row br ai-center amount-masked-input"
        :class="{ 'lightgrey-bkg': disabled, 'b-1': !disabled }"
    >
        <el-input
            v-model="currentValue"
            type="text"
            :placeholder="placeholder"
            :disabled="disabled"
            @blur="isFocus = false"
            @focus="isFocus = true"
        >
        </el-input>
        <span :data-symbol="symbol" class="currency-symbol pr-2 nowrap"></span>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const corpMapState = createNamespacedHelpers('corp').mapState;

export default {
    props: {
        modelValue: {
            type: [Number, String],
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        symbol: {
            type: String,
            required: false,
            default: window.App.numformat.currencysymbol,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        numFormat: {
            type: Object,
            required: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isFocus: false,
            numberFormat: {},
        };
    },
    computed: {
        ...corpMapState({
            numberFormatState: 'numformat',
        }),
        position() {
            switch (this.numberFormat.currencypos) {
                case 'left':
                    return 'prefix';
                case 'right':
                default:
                    return 'suffix';
            }
        },
        /**
         * On blur, set numformat of corp.
         * In case of decimals is set with "," we convert value by NBF for decimals calculation compatibility in parent form
         */
        currentValue: {
            get: function () {
                if (_.isNil(this.modelValue)) {
                    return null;
                }
                if (this.isFocus) {
                    return this.modelValue.toString();
                } else {
                    return this.modelValue.toString().includes(',')
                        ? NumberFormat.convert(
                            this.modelValue,
                            { ...this.numberFormat, decimals: ',' },
                            this.numberFormat,
                            this.numberFormat.precision,
                        )
                        : NumberFormat.formatToDisplay(this.modelValue, this.numberFormat);
                }
            },
            set: function (newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },
    created() {
        this.numberFormat = this.numFormat ? this.numFormat : this.numberFormatState;
    },
};
</script>
<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.currency-symbol {
    &::before {
        content: attr(data-symbol);
        color: $gray-100;
    }
}
</style>
<style scoped lang="scss">
.amount-masked-input {
    :deep(.el-input__wrapper) {
        box-shadow: none !important;
    }
}
</style>
